





















































import Modal from "../core/Modals/Modal.vue";
import JournalFolderSelect from "../core/Forms/JournalFolderSelect.vue";
import { JournalApi } from "../api/JournalApi";

export default {
    name: "MergeFoldersModal",
    components: { JournalFolderSelect, Modal },
    props: {
        showModal: Boolean,
    },
    data() {
        return {
            selectedFolderA: null,
            selectedFolderB: null,
            saving: false,
            JournalApi: new JournalApi(),
        };
    },
    methods: {
        closeModal(): void {
            this.$emit("close-modal");
        },
        save(): void {
            let self = this;

            if (self.saving) {
                return;
            }
            if (!self.selectedFolderA) {
                swal(
                    "Veuillez sélectionner un dossier de destination (A)",
                    "",
                    "error"
                );
                return;
            }
            if (!self.selectedFolderB) {
                swal(
                    "Veuillez sélectionner un dossier à fusionner (B)",
                    "",
                    "error"
                );
                return;
            }

            self.saving = true;
            return self.JournalApi.mergeFolders(
                self.selectedFolderA.id,
                self.selectedFolderB.id
            ).then(function () {
                self.saving = false;
                swal("Les dossiers ont été fusionnés.", "", "success");
                self.closeModal();
            });
        },
    },
};
